/* eslint-disable @typescript-eslint/no-explicit-any */
export function extractConversationId(conv: any): string {
  return (
    conv?.uuid || conv?.id || conv?.key?.replace('#conversation#', '') || ''
  );
}
